/*🤫
🤫
🤫*/
export const patternName = "text-expander";

/*🤫
🤫
🤫*/
export type PatternName = typeof patternName;
